import { Link } from 'react-router-dom';
import { useNextTask, useResolverUrl } from '../utils/hooks';

export const SkipButton = () => {
  const nextTask = useNextTask();
  const resolverUrl = useResolverUrl();

  if (nextTask) {
    return (
      <Link
        to={`${resolverUrl}/task/${nextTask.id}`}
        className="shrink-0 text-teal-700 underline"
      >
        Skip for now
      </Link>
    );
  }

  return null;
};
